/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Roletemplates1Inputs */

const en_entity_roletemplates1 = /** @type {(inputs: Entity_Roletemplates1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role Templates`)
};

const de_entity_roletemplates1 = /** @type {(inputs: Entity_Roletemplates1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rollenvorlagen`)
};

/**
* | output |
* | --- |
* | "Role Templates" |
*
* @param {Entity_Roletemplates1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_roletemplates1 = /** @type {((inputs?: Entity_Roletemplates1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Roletemplates1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_roletemplates1(inputs)
	return de_entity_roletemplates1(inputs)
});
export { entity_roletemplates1 as "entity_roleTemplates" }